(function () {
  const setupHover = (section) => {
    const steps = section.querySelectorAll('[data-deco-step]');
    const supportsHover = window.matchMedia('(hover: hover)').matches;
    if (!steps.length || !supportsHover) return;

    steps.forEach((step) => {
      const idx = step.dataset.decoStep;
      const marker =
        section.querySelector(`[data-deco-zoom="${idx}"]`) ||
        section.querySelector(`[data-deco-pin="${idx}"]`);
      if (!marker) return;
      const show = () => marker.classList.add('is-visible');
      const hide = () => marker.classList.remove('is-visible');
      step.addEventListener('mouseenter', show);
      step.addEventListener('mouseleave', hide);
      step.addEventListener('focusin', show);
      step.addEventListener('focusout', hide);
    });
  };

  const initGsap = (section) => {
    if (!window.gsap || !window.ScrollTrigger) return;
    const { gsap, ScrollTrigger } = window;
    gsap.registerPlugin(ScrollTrigger);

    const track = section.querySelector('[data-deco-track]');
    const steps = section.querySelectorAll('[data-deco-step]');
    const zooms = section.querySelectorAll('[data-deco-zoom]');
    const pins = section.querySelectorAll('[data-deco-pin]');
    if (!track || !steps.length) return;

    const panStart = -parseFloat(section.dataset.panStart || '7');
    const panEnd = -parseFloat(section.dataset.panEnd || '63');
    const scrollLength = parseFloat(section.dataset.scrollLength || '4');

    // Segments: [intro, step1, step2, ..., stepN] — N+1 equal slices of scroll progress.
    // Frame 1 of flow 14 is an intro without any zoom circle; subsequent frames each
    // highlight one step.
    const segments = steps.length + 1;

    // Match markers (zooms + standalone pins) to steps by attribute value rather than
    // NodeList position, so steps without a rendered marker don't shift indexes.
    const setActive = (stepIdx) => {
      steps.forEach((el, i) => el.classList.toggle('is-active', i === stepIdx));
      const activeKey = stepIdx >= 0 ? steps[stepIdx]?.dataset.decoStep : null;
      zooms.forEach((el) => el.classList.toggle('is-active', el.dataset.decoZoom === activeKey));
      pins.forEach((el) => el.classList.toggle('is-active', el.dataset.decoPin === activeKey));
    };

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      gsap.set(track, { yPercent: panEnd });
      setActive(steps.length - 1);
      return;
    }

    gsap.set(track, { yPercent: panStart });

    ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      end: `+=${scrollLength * 100}%`,
      pin: true,
      pinSpacing: true,
      scrub: 0.6,
      invalidateOnRefresh: true,
      onUpdate: (self) => {
        const p = self.progress;
        gsap.set(track, { yPercent: panStart + (panEnd - panStart) * p });
        // Segment 0 = intro (no active step), 1..N map to step indices 0..N-1.
        const seg = Math.min(segments - 1, Math.floor(p * segments));
        setActive(seg - 1);
      },
      onLeaveBack: () => {
        gsap.set(track, { yPercent: panStart });
        setActive(-1);
      },
    });
  };

  const init = () => {
    document.querySelectorAll('[data-deconstruction]').forEach((section) => {
      setupHover(section);
      initGsap(section);
    });
  };

  const loadGsap = (cb) => {
    if (window.gsap && window.ScrollTrigger) return cb();
    const load = (src) =>
      new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = src;
        s.async = true;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });
    load('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js')
      .then(() => load('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js'))
      .then(cb)
      .catch(cb);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => loadGsap(init));
  } else {
    loadGsap(init);
  }
})();
